import styled, { css, DefaultTheme } from 'styled-components';

import { Grid as SimpleGrid } from '../Layout/Grid/styles';
import { Row } from '../Layout/Row/styles';

import { GridContainerProps } from './types';

export const Section = styled(SimpleGrid)``;

export const Card = styled(Row)``;

const modifier = {
	light: (theme: DefaultTheme) => css`
		.item {
			border: 1px solid #e0e0e0;
		}
		.item:nth-child(1),
		.item:nth-child(4) {
			outline: 2px solid transparent;
		}
		.item:nth-child(1),
		.item:nth-child(4) {
			&:hover {
				outline: 1px solid ${theme.colors.portoSeguros100};
				border: 1px solid ${theme.colors.portoSeguros100};
			}
		}
	`,
	dark: (theme: DefaultTheme) => css`
		.item {
			border: 1px solid transparent;
		}

		.item:nth-child(1),
		.item:nth-child(4) {
			outline: 2px solid transparent;
		}
		.item:nth-child(1),
		.item:nth-child(4) {
			&:hover {
				outline: 1px solid ${theme.colors.portoSeguros45};
				border: 1px solid ${theme.colors.portoSeguros45};
			}
		}
	`,
};

export const GridContainer = styled.div<GridContainerProps>`
	${({ theme, mode }) => css`
		display: flex;
		flex-direction: column;
		gap: 40px;

		.item {
			border-radius: 12px;
			overflow: hidden;
			position: relative;
		}

		.item:nth-child(1) {
			order: 1;
		}

		.item:nth-child(2) {
			order: 3;
		}

		.item:nth-child(3) {
			order: 2;
		}

		.item:nth-child(4) {
			order: 4;
			margin-top: -26px;
		}

		${!!mode && modifier[mode](theme)};

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			display: block;
			column-count: 2;
			column-gap: 24px;
			width: 681px;
			margin: 0 auto;

			.item {
				margin-bottom: 24px;
				break-inside: avoid;
			}
			.item:nth-child(4) {
				margin-top: 0px;
			}
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			width: 894px;
			column-gap: 16px;

			.item {
				margin-bottom: 16px;
			}
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			width: 100%;
			display: grid;
			grid-template-columns: 42.3rem 33.3rem 24.4rem;
			column-gap: 24px;
			row-gap: 16px;
			align-items: start;
			justify-content: center;

			.item {
				margin-bottom: 0px;
			}
			.item:nth-child(1) {
				width: 423px;
				grid-row: 1 / 3;
			}
			.item:nth-child(2) {
				width: 244px;
				margin-left: auto;
			}
			.item:nth-child(3) {
				width: 333px;
				grid-row: 1 / 3;
				order: 2;
				margin: 0 auto;
			}
			.item:nth-child(4) {
				width: 244px;
				margin-left: auto;
			}
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			width: 1592px;

			grid-template-columns: 640px 504px 368px;
			height: 637px;
			column-gap: 40px;
			row-gap: 20px;

			.item:nth-child(1) {
				width: 100%;
			}
			.item:nth-child(2) {
				width: 100%;
			}
			.item:nth-child(3) {
				width: 100%;
			}
			.item:nth-child(4) {
				width: 100%;
			}
		}
	`}
`;
